import {
  AuthorInterface,
  ClassName,
  SlugType,
  TagInterface,
  TrackInterface,
} from "@/helpers/pageHelpers/Common/interface";
import { Block, EntityMap } from "@/components/WysiwygText/interface";

export interface TabsInterface {
  tracklist: TrackInterface[];
  transcript?: {
    blocks: Block[];
    entityMap: EntityMap;
  };
  description: string;
  tags: TagInterface[];
  slug: SlugType;
  authors?: AuthorInterface[];
  title: string;
  className?: ClassName;
}

export interface TranscriptInterface {
  transcript: {
    blocks: Block[];
    entityMap: EntityMap;
  };
  authors?: AuthorInterface[];
  title: string;
  tags?: TagInterface[];
  className?: ClassName;
}

export interface TracklistInterface {
  tracklist: TrackInterface[];
  slug: SlugType;
  className?: ClassName;
}

export interface DescriptionInterface {
  description: string;
  tags?: TagInterface[];
  className?: ClassName;
}

export enum ListVisibilityEnum {
  Collapsed = "collapsed",
  Full = "full",
}

export type TabsContent = "description" | "tracklist" | "transcript";
